import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {environment} from '../environments/environment';
import {AuthGuard, LoggedInGuard} from '@og-lib/core/auth';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('projects/og-lib/src/lib/components/auth/auth.module').then(
        m => m.AuthModule,
      ),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'main',
    loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'gantt',
    loadChildren: () =>
      import('../../../og-lib/src/lib/components/gantt/gantt.module').then(
        m => m.GanttModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: environment.homePath,
    pathMatch: 'full',
  },
  {
    path: 'intra-oral',
    loadChildren: () =>
      import('../app/intra-oral/intra-oral.module').then(
        m => m.IntraOralModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
